export default __webpack_public_path__ + "static/media/acceleY.9e67fe75.svg";